<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display">

  <form class="popup-container patient-setup-popup form-container" #f="ngForm" (ngSubmit)="onSubmit(f)">
    <div class="popup-content">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }}</h2>
      </div>
      <!-- popup body - content view -->
      <div class="popup-body">
        <div class="popup-setup-view" *ngIf="popup?.PopupAction == 'VIEW'">
          <div class="setup-view-title">
            <div class="title">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5657 21.1042C11.2017 21.2447 10.7984 21.2447 10.4343 21.1042C7.59109 19.9894 5.14978 18.0437 3.42868 15.5209C1.70758 12.9982 0.786563 10.0153 0.785721 6.96136V2.35707C0.785721 1.9403 0.951282 1.54061 1.24598 1.2459C1.54068 0.951206 1.94038 0.785645 2.35715 0.785645H19.6429C20.0596 0.785645 20.4594 0.951206 20.754 1.2459C21.0487 1.54061 21.2143 1.9403 21.2143 2.35707V6.94564C21.2166 10.0023 20.297 12.9886 18.5757 15.5144C16.8545 18.0404 14.4114 19.9883 11.5657 21.1042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4.45744 16.8618C5.86577 14.749 8.27036 13.3569 11.0001 13.3569C13.7298 13.3569 16.1343 14.749 17.5427 16.8618" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11 11.0001C12.9527 11.0001 14.5357 9.41715 14.5357 7.46443C14.5357 5.51171 12.9527 3.92871 11 3.92871C9.04729 3.92871 7.46429 5.51171 7.46429 7.46443C7.46429 9.41715 9.04729 11.0001 11 11.0001Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Employment Details</h3>
            </div>
            <div class="content-group">
              <label>Employment Start Date:</label>
              <p>{{staffMember.StartDate}}</p>
            </div>
          </div>
          <div class="content-group">
            <label>ID Number</label>
            <p>{{staffMember.IDNumber}}</p>
          </div>
          <div class="patient-details">
            <div class="details-column">
              <div class="content-group">
                <label>Title:</label>
                <p>{{staffMember.Title}}</p>
              </div>
              <div class="content-group">
                <label>Gender:</label>
                <p>{{staffMember.Gender}}</p>
              </div>
            </div>
            <div class="details-column">
              <div class="content-group">
                <label>Patient Name:</label>
                <p>{{staffMember.Name}}</p>
              </div>
              <div class="content-group">
                <label>Cellphone:</label>
                <p>{{staffMember.Cellphone}}</p>
              </div>
              <!--<div class="content-group">
    <label>Email Address:</label>
    <p>{{staffMember.Email}}</p>
  </div>-->
            </div>
            <div class="details-column">
              <div class="content-group">
                <label>Department Status:</label>
                <p><strong>{{staffMember.Department}}</strong></p>
              </div>
              
            </div>
          </div>
          <hr />
          <div class="content-group">
            <label>Income Tax Number:</label>
            <p>{{staffMember.IncomeTaxNumber}}</p>
          </div>
          <hr />
          <div class="setup-view-title">
            <div class="title">
              <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.9869 18.5064L2.47218 10.6303C-2.16834 5.96854 4.60086 -3.05705 10.9869 4.24431C17.3729 -3.03576 24.206 5.98984 19.5016 10.6303L10.9869 18.5064Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.52301 9.6123H7.92926L9.5498 6.51855L12.0052 12.215L14.1168 9.6123H16.4739" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Medical Information</h3>
            </div>
          </div>
          <div class="popup-details">
            <div class="details-column">
              <div class="details-row" style="justify-content: start;">
                <div class="content-group">
                  <label>Medical Aid:</label>
                  <p>{{staffMember.MedicalAid}}</p>
                </div>
                <div class="content-group">
                  <label>Medical Aid Number:</label>
                  <p>{{staffMember.MedicalAidNumber}}</p>
                </div>
              </div>
              <div class="details-row">
                <div class="content-group">
                  <label>Emergency Contact:</label>
                  <p>{{staffMember.EmergencyContact}}</p>
                </div>
                <div class="content-group">
                  <label>Relationship:</label>
                  <p>{{staffMember.EmergencyContactRelation}}</p>
                </div>
                <div class="content-group">
                  <label>Cellphone:</label>
                  <p>{{staffMember.EmergencyContactCellphone}}</p>
                </div>
              </div>
            </div>


          </div>
        </div>
        <!-- popup body - setup form -->
        <div class="popup-setup-form gap-30" *ngIf="popup?.PopupAction == 'NEW' || popup?.PopupAction == 'EDIT'">
          <!--Setup New html-->
          <div class="setup-view-title">
            <div class="setup-title row align-center">
              <div class="title row">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7116 21.2142C20.0518 19.1569 18.7558 17.3623 17.0106 16.0891C15.2651 14.8159 13.1605 14.1299 11.0001 14.1299C8.83971 14.1299 6.73511 14.8159 4.98974 16.0891C3.24439 17.3623 1.94842 19.1569 1.2887 21.2142H20.7116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11 14.1428C14.6729 14.1428 17.6504 11.1653 17.6504 7.49241C17.6504 3.81951 14.6729 0.842041 11 0.842041C7.32709 0.842041 4.34961 3.81951 4.34961 7.49241C4.34961 11.1653 7.32709 14.1428 11 14.1428Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M13.1717 10.0657C13.1717 10.0657 12.6199 11.1514 11.0002 11.1514C9.38042 11.1514 8.82861 10.0657 8.82861 10.0657" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17.5299 6.22623C17.515 6.22632 17.5002 6.22637 17.4855 6.22637C15.5523 6.22637 13.8168 5.38064 12.6286 4.03902C11.4404 5.38067 9.70486 6.22642 7.77177 6.22642C6.64923 6.22642 5.5933 5.94122 4.67249 5.43934C5.53762 2.77119 8.04347 0.842041 10.9999 0.842041C14.2398 0.842041 16.9386 3.15891 17.5299 6.22623Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Staff Member</h3>
              </div>
              <div class="row gap-10 align-center">
                <span *ngIf="staffMemberError && submitted" class="error-message">*</span>
                <div class="form-group" [ngClass]="{'invalid-border': staffMemberError && submitted}">
                  <app-custom-dropdown [options]="staffList"
                                       [placeholder]="'Select an option'"
                                       [(ngModel)]="staffMember.AgentID"
                                       [optionsText]="'FullName'"
                                       [optionsValue]="'ID'"
                                       [ngModelOptions]="{standalone: true}"
                                       tabindex="1">
                  </app-custom-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="title" *ngIf="popup?.PopupAction == 'NEW'">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.5657 21.1042C11.2017 21.2447 10.7984 21.2447 10.4343 21.1042C7.59109 19.9894 5.14978 18.0437 3.42868 15.5209C1.70758 12.9982 0.786563 10.0153 0.785721 6.96136V2.35707C0.785721 1.9403 0.951282 1.54061 1.24598 1.2459C1.54068 0.951206 1.94038 0.785645 2.35715 0.785645H19.6429C20.0596 0.785645 20.4594 0.951206 20.754 1.2459C21.0487 1.54061 21.2143 1.9403 21.2143 2.35707V6.94564C21.2166 10.0023 20.297 12.9886 18.5757 15.5144C16.8545 18.0404 14.4114 19.9883 11.5657 21.1042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4.45744 16.8618C5.86577 14.749 8.27036 13.3569 11.0001 13.3569C13.7298 13.3569 16.1343 14.749 17.5427 16.8618" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11 11.0001C12.9527 11.0001 14.5357 9.41715 14.5357 7.46443C14.5357 5.51171 12.9527 3.92871 11 3.92871C9.04729 3.92871 7.46429 5.51171 7.46429 7.46443C7.46429 9.41715 9.04729 11.0001 11 11.0001Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Employee Details</h3>
          </div>

          <hr />
          <div class="title" *ngIf="popup?.PopupAction == 'EDIT'">
            <h3>Update Staff Member Details</h3>
          </div>
          <small *ngIf="popup?.PopupAction == 'EDIT'" style="color: var(--error-color);">*Only fill in the section that has to be updated and click on ‘Save’</small>
          <!---->
          <div class="details-row" *ngIf="popup?.PopupAction == 'NEW'">
            <div class="form-group row align-center">
              <label>Employment Start Date:</label>
              <app-calendar-dropdown [(selectedDate)]="staffMember.StartDate"></app-calendar-dropdown>
            </div>
            <div class="form-group">
              <span *ngIf="IncomeTaxNumber.invalid && submitted" class="invalid-text">*</span>
              <label>Income Tax Number:</label>
              <input type="text" class="input-control" placeholder="Enter Employee Income Tax" [(ngModel)]="staffMember.IncomeTaxNumber" id="IncomeTaxNumber" name="IncomeTaxNumber" #IncomeTaxNumber="ngModel"/>
            </div>
          </div>
          <hr />
          <div class="form-group">
            <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
            <label>Employee ID:</label>
            <input type="text" class="input-control" placeholder="Enter Employee ID Number" [(ngModel)]="staffMember.IDNumber" id="IDNumber" name="IDNumber" #IDNumber="ngModel" [ngClass]="{'invalid-border': IDNumber.invalid && submitted}" required/>
          </div>

          <!---->
          <!--Setup Pateint detail fields html-->
          <div class="row">
            <div class="form-group row align-center">
              <span *ngIf="DepartmentError && submitted" class="error-message">*</span>
              <label>Department:</label>
              <app-custom-dropdown [options]="departments"
                                   [placeholder]="'Select an option'"
                                   [(ngModel)]="staffMember.RoleID"
                                   [optionsText]="'RoleName'"
                                   [ngModelOptions]="{standalone: true}"
                                   [optionsValue]="'ID'"
                                   [ngClass]="{'invalid-border': DepartmentError && submitted}">
              </app-custom-dropdown>
            </div>
          </div>
          <div class="patient-details">
            <!--detail group-->
            <div class="details-column">
              <div class="form-group row align-center">
                <app-custom-dropdown [options]="titles"
                                     [placeholder]="'Title'"
                                     [(ngModel)]="staffMember.Title"
                                     [optionsText]="'Type'"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsValue]="'Type'">
                </app-custom-dropdown>
              </div>
              <div class="form-group row align-center">
                <app-custom-dropdown [options]="genders"
                                     [placeholder]="'Gender'"
                                     [(ngModel)]="staffMember.Gender"
                                     [optionsText]="'Type'"
                                     [ngModelOptions]="{standalone: true}"
                                     [optionsValue]="'Type'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="details-column">
              <div class="form-group">
                <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
                <label>Employee Name:</label>
                <input type="text" class="input-control" placeholder="Enter Employee Name" [(ngModel)]="staffMember.Name" id="Name" name="Name" #Name="ngModel" [ngClass]="{'invalid-border': Name.invalid && submitted}" required style="text-transform: uppercase;" />
              </div>
              <div class="form-group">
                <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
                <label>Cellphone:</label>
                <input type="tel" class="input-control" placeholder="Enter Employee Cellphone Number" [(ngModel)]="staffMember.Cellphone" id="Cellphone" name="Cellphone" #Cellphone="ngModel" [ngClass]="{'invalid-border': Cellphone.invalid && submitted}" required />
              </div>
            </div>
            <div class="details-column">
              <div class="form-group">
                <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
                <label>Employee Surname:</label>
                <input type="text" class="input-control" placeholder="Enter Employee Surname" [(ngModel)]="staffMember.Surname" id="Surname" name="Surname" #Surname="ngModel" [ngClass]="{'invalid-border': Surname.invalid && submitted}" required style="text-transform: uppercase;" />
              </div>
              <div class="form-group">
                <span *ngIf="Email.invalid && submitted" class="invalid-text">*</span>
                <label>Employee Email:</label>
                <input type="tel" class="input-control" placeholder="Enter Employee Email" [(ngModel)]="staffMember.Email" id="Email" name="Email" #Email="ngModel" [ngClass]="{'invalid-border': Email.invalid && submitted}" required />
              </div>
            </div>
          </div>
          <hr />
          <div class="details-row">
            <div class="form-group" style=" width: fit-content;">
              <span *ngIf="!staffMember.ProvinceID && submitted" class="error-message">*</span>
              <label>Province:</label>
              <app-custom-dropdown [options]="provinces"
                                   [placeholder]="'Select a province'"
                                   [(ngModel)]="staffMember.ProvinceID"
                                   [ngModelOptions]="{standalone: true}"
                                   [optionsText]="'Type'"
                                   [optionsValue]="'ID'"
                                   (ngModelChange)="ChangeStaffBranch()"
                                   [ngClass]="{'invalid-border': !staffMember.ProvinceID && submitted}">
              </app-custom-dropdown>
            </div>
            <div class="form-group" style=" width: fit-content;" *ngIf="staffMember.ProvinceID > 0">
              <span *ngIf="BranchError && submitted" class="error-message">*</span>
              <label>Branch:</label>
              <app-custom-dropdown [options]="branches"
                                   [placeholder]="'Select a branch'"
                                   [(ngModel)]="staffMember.BranchID"
                                   [ngModelOptions]="{standalone: true}"
                                   [optionsText]="'BranchName'"
                                   [optionsValue]="'ID'"
                                   [ngClass]="{'invalid-border': BranchError && submitted}">
              </app-custom-dropdown>
            </div>
          </div>
          <hr />
          <div class="details-column">
            <div class="form-group">
              <label>Medical Aid:</label>
              <input type="text" class="input-control" placeholder="Enter Employee Medical Aid" [(ngModel)]="staffMember.MedicalAid" [ngModelOptions]="{standalone: true}"/>
            </div>
            <div class="details-row">
              <!--detail group-->
              <div class="form-group">
                <label>Medical Aid Number:</label>
                <input type="text" class="input-control" placeholder="Enter Medical Aid Number" [(ngModel)]="staffMember.MedicalAidNumber" [ngModelOptions]="{standalone: true}"/>
              </div>
              <div class="form-group">
                <label>Emergency Contact:</label>
                <input type="text" class="input-control" placeholder="Enter Emergency Contact" [(ngModel)]="staffMember.EmergencyContact" [ngModelOptions]="{standalone: true}"/>
              </div>
            </div>
            <div class="details-row">
              <!--detail group-->
              <div class="form-group">
                <label>Relationship:</label>
                <input type="text" class="input-control" placeholder="Enter Contact Relation" [(ngModel)]="staffMember.EmergencyContactRelation" [ngModelOptions]="{standalone: true}"/>
              </div>
              <div class="form-group">
                <label>Cellphone:</label>
                <input type="tel" class="input-control" placeholder="Enter Contact Cellphone" [(ngModel)]="staffMember.EmergencyContactCellphone" [ngModelOptions]="{standalone: true}" />
              </div>

            </div>
          </div>

          <hr />
          <div class="details-row" *ngIf="popup?.PopupAction == 'EDIT'">
            <!--detail group-->
            <label style="color: var(--primary-color);">Terminate Employment:</label>

            <div style="display: flex; flex-flow: row; gap: 15px;">
              <div class="form-group" style="flex-flow: column; align-items: baseline;">
                <label>Date</label>
                <app-calendar-dropdown [(selectedDate)]="staffMember.EndDate"></app-calendar-dropdown>
              </div>
            </div>

          </div>
          <!---->
        </div>
        <div class="popup-buttons" *ngIf="popup?.PopupAction != 'VIEW'">
          <button type="submit" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.Result" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
      <div class="appointment-history column" *ngIf="popup?.PopupAction == 'VIEW'">
        <div class="popup-header" *ngIf="activityHistory.length > 0" >
          <h1>Activity History</h1>
        </div>
        <div class="custom-table" *ngIf="activityHistory.length > 0" >
          <div class="details-row history-details" *ngFor="let activity of activityHistory">
            <div class="detail-group">
              <p><span>{{activity.ActionDate}}</span></p>
              <p>{{activity.Action}}</p>
            </div>
            <div class="detail-group">
              <p><span>{{activity.AgentName}}</span></p>
            </div>
            <div class="detail-group">
              <p><span>{{activity.ActionDetails}}</span></p>
              <p> Ear Institute {{activity.BranchName}}</p>
            </div>
            <div class="detail-group">
              <p><span>{{activity.ActionResult}}</span></p>
              <p style="font-style: italic">{{activity.ActionResult2}}</p>
            </div>
          </div>
        </div>
        <div class="popup-buttons" style=" padding: 0px 30px 30px;">
          <button *ngIf="activityHistory.length > 0" type="button" (click)="ButtonClick()" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.Result" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
    </div>
  </form>
</div>
